module.exports = __webpack_public_path__ + "img/pic_5.a1bcfbaa.png";